import React from "react";

export function Metric({ label, value, sub, accent = false, testId }) {
  return (
    <div
      data-testid={testId}
      className={`grid-surface p-6 flex flex-col justify-between h-full ${
        accent ? "border-l-4 border-l-brand-500" : ""
      }`}
    >
      <div className="overline text-stone-500">{label}</div>
      <div className="mt-4">
        <div className="font-display text-4xl font-black tracking-tight text-stone-950">
          {value}
        </div>
        {sub && <div className="text-sm text-stone-500 mt-1">{sub}</div>}
      </div>
    </div>
  );
}
